import React from "react";
import { GridWrapper } from "../../GridWrapper/GridWrapper";
import { Card } from "../../card";
import { AddAcademicPrices } from "./AddAcademicPrices";
import { AcademicPricesLists } from "./AcademicPricesLists";

export const AcademicPrices = () => {
  return (
    <GridWrapper
      totalColumns={5}
      childrens={[
        {
          component: (
            <Card
              cardTitle="Manage Class Fees"
              cardSubTitle="Set up and manage class-wise fees. Specify admission, annual, and other fees for each class easily."
            >
              <AddAcademicPrices />
            </Card>
          ),
          gridSpan: 2,
        },
        {
          component: (
            <Card cardTitle="All Academic Prices">
              <AcademicPricesLists />
            </Card>
          ),
          gridSpan: 3,
        },
      ]}
    />
  );
};
